module.exports = __webpack_public_path__ + "first-50_ir.jpg?f9083b7a809788d685decf867775e09c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-50_ir.jpg
// module id = 570
// module chunks = 0